import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

function IndexCTA() {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 600);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const handleWhatsappClick = (local) => {
    const localMap = {
      'sarandi': '5544991295607',
      'marialva': '5544991225656'
    }
    window.location.href = `https://api.whatsapp.com/send?phone=${localMap[local]}`;
  };

  const [contatoModalOpen, setContatoModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", text: "", image: "" });


  const openContatoModal = (service) => {
    setContatoModalOpen(true);
  };

  const closeModal = () => {
    setContatoModalOpen(false);
  };

  const handleClickOutside = (e) => {
    if (e.target.id === "modal-container") {
      closeModal();
    }
  };

  return (
    <>{isSmallScreen ? (
      <div className='p-10 flex flex-col gap-2 text-blue-800 bg-slate-100'>
        <div className='text-right flex flex-col m-2 items-end'>
          <h3 className='archivo-black-regular2 -mb-0 text-4xl'>SUA VISÃO,</h3>
          <h3 className='archivo-black-regular2'> MUITO MAIS NÍTIDA!</h3>
        <div onClick={openContatoModal} className='bg-green-500 text-slate-200 font-extrabold p-3 rounded-xl shadow-md cursor-pointer hover:bg-green-400'> ENTRE EM CONTATO <FontAwesomeIcon icon={faWhatsapp}/></div>
      </div>
      <div className='font-semibold p-10 text-[13pt]'> 
      <p>Ao escolher a <span className='font-extrabold text-blue-500 text-[14pt]'>Clínica Horus</span>, você garante não apenas um atendimento oftalmológico excepcional, mas também <span className='text-yellow-400 text-[14pt]'>o cuidado e a precisão de quem se dedica à sua visão!</span> <br/><br/>Não espere mais. Cuide da sua saúde ocular com especialistas. Escolha a Clínica Horus e enxergue um futuro mais claro.</p>
      </div>
      </div>
    ):(
      <div className='p-10 flex gap-2 text-blue-800 bg-slate-100'>
      <div className='text-right flex flex-col w-2/5 m-2 items-end'>
      <h3 className='archivo-black-regular2 -mb-0 text-4xl'>SUA VISÃO,</h3>
      <h3 className='archivo-black-regular2'> MUITO MAIS NÍTIDA!</h3>
      <div onClick={openContatoModal} className='bg-green-500 text-slate-200 font-extrabold p-3 rounded-xl shadow-md cursor-pointer hover:bg-green-400'> ENTRE EM CONTATO <FontAwesomeIcon icon={faWhatsapp}/></div>
      </div>
      <div className='font-semibold w-3/5 p-10 text-[13pt]'>    
      <p>Ao escolher a <span className='font-extrabold text-blue-500 text-[14pt]'>Clínica Horus</span>, você garante não apenas um atendimento oftalmológico excepcional, mas também <span className='text-yellow-400 text-[14pt]'>o cuidado e a precisão de quem se dedica à sua visão!</span> <br/><br/>Não espere mais. Cuide da sua saúde ocular com especialistas. Escolha a Clínica Horus e enxergue um futuro mais claro.</p></div>
      </div>
    )}
    
    
    {contatoModalOpen && (
        <div 
          id="modal-container" 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={handleClickOutside}
        >
          <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 md:w-1/2 lg:w-1/3 relative">
            <button 
              className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
              onClick={closeModal}
            >
              &times;
            </button>
            <h3 className="text-xl font-semibold text-blue-900 mb-2">Estamos situados em dois endereços!</h3>
            
            <div className="flex flex-row gap-4 justify-center align-middle p-4 items-center"> 
              <button
                className="mt-6 max-w-[200px] rounded-full px-6 self-center py-3 bg-blue-500 text-white font-bold hover:bg-blue-600"
                onClick={handleWhatsappClick('sarandi')}
              >
                Falar c/ Sarandi
              </button>
              <button
                className="mt-6 max-w-[200px] rounded-full px-6 self-center py-3 bg-blue-500 text-white font-bold hover:bg-blue-600"
                onClick={handleWhatsappClick('marialva')}
              >
                Falar c/ Marialva
              </button>
            </div>


          </div>
        </div>
      )}
    </>

  )
}

export default IndexCTA